'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'react-tag-select/TAG_REJECTED';